import { observer } from 'mobx-react-lite';
import { QRFunc } from 'react-qrbtf';
import copy from 'copy-to-clipboard';
import Other from '@/common/helper/other';
import { toBlob }  from "html-to-image";

const QrcodeShare = observer(({ url = "" }) => {
	return (
		<div className="w-240px h-285px flex flex-col items-center justify-center bg-white">
			<div className='size-140px rounded-6px border-1px border-black border-opacity-16 overflow-hidden bg-white'>
				<div className='size-full transform scale-128 origin-center relative qrcode-wrapper bg-white'>
					<QRFunc
						value={url}
						icon='https://p2.ssl.qhimg.com/t110b9a9301b795f6cf45894018.png'
					/>
					<img 
						src="https://p2.ssl.qhimg.com/t110b9a9301b795f6cf45894018.png" 
						className='absolute top-[50%] left-[50%] transform -translate-x-[50%] -translate-y-[50%] bg-white size-30px'
					/>
				</div>
			</div>
			<div 
				className='w-140px h-36px bg-black rounded-8px text-center leading-36px text-white text-14px mt-8px cursor-pointer hover:bg-[#333333]'
				onClick={async () => {
					const blob = await toBlob(document.querySelector(".qrcode-wrapper"))
					blob && navigator?.clipboard?.write([
						new ClipboardItem({
								[blob.type]: blob
						})
					]).then(() => {
						Other.toast('复制成功', "success");
					}).catch(() => {
						Other.toast('复制失败', "warning");
					})
				}}
			>
				复制二维码
			</div>
			<div className='w-200px h-1px bg-black bg-opacity-10 my-12px'>
			</div>
			<div className='w-200px h-36px box-border border-1px border-solid rounded-8px border-black border-opacity-10 flex items-center justify-center gap-11px bg-[#f5f5f5]'>
				<div className='w-117px text-14px text-black text-opacity-50 line-clamp-1'>
				  {url}
				</div>
				<div
					className='text-[#006AFF] text-14px cursor-pointer hover:text-[#005EE3]'
					onClick={() => {
						const copied = copy(url);
            			copied && Other.toast('复制成功', "success");
					}}
				>
					复制链接
				</div>
			</div>
		</div>
	);
});
  
export default QrcodeShare;